module.exports = __webpack_public_path__ + "img/i.67de0a93.png";